<template>
    <Footer class="layout-footer-center ">
        <div class="header">
            <ul class="link-group">
                <li class="link-item" v-for="(item,index) in linkList" :key="index" @click="selectMenuItem(item)">
                    <span class="text">{{item.name}}</span>
                </li>
            </ul>
            <div class="copyright">
                <div>Copyright © 2019 www.shhz.org.cn 版权所有 上海市殡葬服务中心</div>
                <div style="padding-top: 10px;"><a href="http://beian.miit.gov.cn/" target="_blank">沪ICP备19019356号</a> 技术支持：上海飞信信息</div>
            </div>
            <div class="line"></div>
        </div>
    </Footer>
</template>

<script>
    export default {
        name: "commonFooter",
        data(){
            return{
                linkList:[{
                    name:'首页',
                    key:'Home',
                },{
                    name:'网上祭扫',
                    key:'memorial'
                },{
                    name:'新闻中心',
                    key:'news',
                },
                // {
                //     name:'海葬预约',
                //     key:'order',
                // },
                {
                    name:'联系我们',
                    key:'about',
                }]
                // ,{
                //     name:'申请纪念堂',
                //     key:''
                // }
                // ,{
                //     name:'上海殡仪网',
                //     key:'http://www.shbz.org/'
                // }
            }
        },
        methods:{
            selectMenuItem (item) {
                if(!item.key)return
                if(item.key=='http://www.shbz.org/'){
                    window.open('http://www.shbz.org/')
                    return
                }
                if(item.key=='creatMemorial'){
                    this.$emit('creatMemorial')
                    return
                }
                this.$router.push({
                    path: `/${item.key}/`
                })
            },
        }
    }
</script>

<style scoped lang="scss">

    .layout-footer-center {
        text-align: center;
        height: 200px;
        background-color: #333;
        position: relative;
    }
    .header{
        max-width: 568px;
        margin: 0 auto;
        .link-group{
            color: #E6E6E6;
            font-size: 16px;
            overflow: hidden;
            padding: 18px 20px 35px 120px;
            .link-item{
                float: left;
                margin-right: 23px;
                &:hover{
                    cursor: pointer;
                    span.text{
                        color: #fff;
                    }
                }
            }
        }
        .copyright{
            color: #9B9B9B;
            font-size: 14px;
        }
        .line{
            position: absolute;
            left: 0;
            top: 88px;
            width: 100%;
            border-bottom: 1px solid #7B7B7B;
        }
    }

</style>
